import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingComponent } from './billing/billing.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FinancialsComponent } from './financials/financials.component';
import { LohiDashboardComponent } from './lohi-dashboard.component';
import { PerformanceComponent } from './performance/performance.component';
import { RegionalNewsComponent } from './regional-news/regional-news.component';
import { SettlementComponent } from './settlements/settlement.component';

const routes: Routes = [
  {
    path: '',
    component: LohiDashboardComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'performance', component: PerformanceComponent },
      { path: 'financials', component: FinancialsComponent },
      { path: 'regional-news', component: RegionalNewsComponent },
      {
        path: 'drivers',
        loadChildren: () => import('./drivers/drivers.module').then((m) => m.DriversModule),
      },
      { path: 'settlements/:id', component: SettlementComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'billing-export',
        component: BillingComponent,
      },
      {
        path: 'loads',
        loadChildren: () => import('./loads/loads.module').then((m) => m.LoadsModule),
      },
      {
        path: 'eld_management',
        loadChildren: () => import('./eld/eld.module').then((m) => m.EldModule),
      },
      {
        path: 'driver-cuts',
        loadChildren: () =>
          import('./driver-cut-management/driver-cut-management.module').then((m) => m.DriverCutManagementModule),
      },
      {
        path: 'scheduling',
        loadChildren: () =>
          import('./schedule-blocking/schedule-blocking.module').then((m) => m.ScheduleBlockingModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LohiDashboardRoutingModule {}
